import styled from 'styled-components'

const styledComponent = styled.div`
  position: relative;
  display: flex;
  margin-right: 10px;
`
styledComponent.displayName = 'RadioContainer'
export default styledComponent
